import styled from 'styled-components';
import { space } from 'nicollet-tokens';
import { Heading as StyledHeading } from '../Heading/index.js';

const CellContent = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  min-height: 64px;

  ${StyledHeading} {
    text-align: left;
    margin: ${space.generic.x4} auto ${space.generic.x4} ${space.generic.x4};
  }
`;

export { CellContent };
